<sm-container-list-item
  [container]="container"
  [searchQuery]="searchQuery"
  [inventoryMenu]="inventoryMenu"
  [menuItems]="menuItems"
  [emptyDescriptionLabel]="emptyDescriptionLabel"
  [menuAriaLabel]="menuAriaLabel"
  (open)="handleOpen()"
  (menuItemSelect)="handleMenuItemSelect($event)">
</sm-container-list-item>

@if (result.tags?.length) { <p class="search-result-tags">@for (tag of result.tags; track tag.id) { <span>{{ tag.name }} · {{ tag.authorName }}</span> }</p> }
